import { render } from "./CaseBrowser.vue?vue&type=template&id=ef551f92&scoped=true"
import script from "./CaseBrowser.vue?vue&type=script&lang=js"
export * from "./CaseBrowser.vue?vue&type=script&lang=js"

import "./CaseBrowser.vue?vue&type=style&index=0&id=ef551f92&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef551f92"]])

export default __exports__